import { Component, input } from '@angular/core';

import { BaseChartComponent } from './base-chart/base-chart.component';

@Component({
  selector: 'cam-pie-chart',
  templateUrl: './base-chart/base-chart.component.html',
  styleUrls: ['./base-chart/base-chart.component.scss'],
})
export class CamChartPieComponent extends BaseChartComponent<'pie'> {
  radius = input<number>();

  constructor() {
    super();

    this.type = 'pie';
  }
}
